import { partial } from 'lodash/fp';
import { type as typeUtil } from '@mews/framework';
import ApiComponent from '../apiComponent';
import createRequest from './misc/createRequest';
import searchable from './traits/searchable';

const BASE_URL = '/customers';

export default function CustomerComponent(apiComponent: $TSFixMe) {
    typeUtil.check(apiComponent, ApiComponent);
    const request = createRequest(apiComponent.request, BASE_URL);

    return typeUtil.create(CustomerComponent, searchable(partial(request, ['/search'])), {
        add({
            titlePrefix,
            email,
            firstName,
            lastName,
            nationalityCode,
            birthDateUtc,
            enterpriseId,
            preferredLanguageCode,
            telephone,
            gender,
        }: $TSFixMe) {
            return request('/add', {
                titlePrefix,
                email,
                firstName,
                lastName,
                nationalityCode,
                birthDateUtc,
                enterpriseId,
                preferredLanguageCode,
                telephone,
                gender,
            });
        },

        update({
            customerId,
            email,
            titlePrefix,
            firstName,
            lastName,
            nationalityCode,
            birthDateUtc,
            gender,
            preferredLanguageCode,
            telephone,
        }: $TSFixMe) {
            return request('/update', {
                customerId,
                email,
                titlePrefix,
                firstName,
                lastName,
                nationalityCode,
                birthDateUtc,
                gender,
                preferredLanguageCode,
                telephone,
            });
        },

        addIdentityDocument({
            customerId,
            number,
            type,
            issueDateUtc,
            expiryDateUtc,
            issuingCountryCode,
            issuingCity,
            overwriteExisting = false,
        }: $TSFixMe) {
            return request('/addIdentityDocument', {
                customerId,
                number,
                type,
                issueDateUtc,
                expiryDateUtc,
                issuingCountryCode,
                issuingCity,
                overwriteExisting,
            });
        },

        updateIdentityDocument({
            customerId,
            identityDocumentId,
            number,
            type,
            issueDateUtc,
            expiryDateUtc,
            issuingCountryCode,
            issuingCity,
        }: $TSFixMe) {
            return request('/updateIdentityDocument', {
                customerId,
                identityDocumentId,
                number,
                type,
                issueDateUtc,
                expiryDateUtc,
                issuingCountryCode,
                issuingCity,
            });
        },

        deleteIdentityDocument({ customerId, identityDocumentId }: $TSFixMe) {
            return request('/deleteIdentityDocument', { customerId, identityDocumentId });
        },

        addFile({ customerId, data, name, type }: $TSFixMe) {
            return request('/addFile', { customerId, data, name, type });
        },

        deleteFile({ customerId, fileId }: $TSFixMe) {
            return request('/deleteFile', { customerId, fileId });
        },

        getBalance({ customerIds, enterpriseId }: $TSFixMe) {
            return request('/getBalance', { customerIds, enterpriseId });
        },
    });
}
